import { render, staticRenderFns } from "./SaveStatusWrapper.vue?vue&type=template&id=f508673a&"
import script from "./SaveStatusWrapper.vue?vue&type=script&lang=ts&"
export * from "./SaveStatusWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports